import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import type { Tables } from '@/integrations/supabase/types';
import { useAuth } from '@/contexts/auth-context';

type MandateRow = Tables<'mandates'>;

interface ActiveMandateResult {
  mandate: MandateRow | null;
  loading: boolean;
  error: string | null;
}

export const DEMO_ORGANIZATION_ID = '00000000-0000-0000-0000-000000000001';
export const DEMO_MANDATE_ID = '00000000-0000-0000-0000-000000000002';

export function useActiveMandate(): ActiveMandateResult {
  const { profile } = useAuth();
  const [mandate, setMandate] = useState<MandateRow | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const organizationId = profile?.organization_id;

    if (!organizationId) {
      setMandate(null);
      return;
    }

    setLoading(true);
    setError(null);

    const fetchMandate = async () => {
      const { data, error } = await supabase
        .from('mandates')
        .select('*')
        .eq('organization_id', organizationId)
        .in('status', ['active', 'paused'])
        .order('updated_at', { ascending: false })
        .limit(1)
        .maybeSingle();

      if (error) {
        setError(error.message);
        setMandate(null);
      } else {
        setMandate(data ?? null);
      }
      setLoading(false);
    };

    fetchMandate();
  }, [profile?.organization_id]);

  return { mandate, loading, error };
}
